import { render } from "./milestone-form-footer.vue?vue&type=template&id=406b5bb0&ts=true"
import script from "./milestone-form-footer.vue?vue&type=script&lang=ts"
export * from "./milestone-form-footer.vue?vue&type=script&lang=ts"

import "./milestone-form-footer.vue?vue&type=style&index=0&id=406b5bb0&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__